import React, { Component } from 'react';
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import ImportFromPassword from './ImportFromPassword';
import ProfileInformationContainer from "./ProfileInformationContainer";
import ShowLiveStream from './ShowLiveStream';
import LivestreamCreatorDetails from './LivestreamCreatorDetails';
import NFTSalesLivestream from './NFTSalesLivestream';
import ChatAndFlyingObjects from './ChatAndFlyingObjects';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class LivestreamPage extends Component {
  constructor(props) {
    super(props);
    this.selectModal = this.selectModal.bind(this);

    this.state = {
      modalShown: '',
    }
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  render() {
    return (
      <div className="min-h-screen">
        <div>
          <PlatformSidebar
            modalShown={this.state.modalShown}
            selectModal={this.selectModal}
          />
          {
            this.state.modalShown === 'createAccount'
              ?
            <Onboarding selectModal={this.selectModal} />
              :
            this.state.modalShown === 'addFunds'
              ?
            <AddFunds selectModal={this.selectModal} />
              :
            this.state.modalShown === 'importFromPassword'
              ?
            <ImportFromPassword selectModal={this.selectModal} />
              :
            null
          }
        </div>
        <div className="flex w-screen justify-center">
          <div className="flex flex-col">
            <div className="md:flex md:flex-row flex-col">
              <div className="md:flex hidden">
                <NFTSalesLivestream
                  address={this.props.account != null ? this.props.account.address : null}
                  setTransactionStatus={this.props.setTransactionStatus}
                  nftSalesLivestream={this.props.nftSalesLivestream}
                />
              </div>
              <div className="dark:bg-custom-black bg-custom-white border-r-2 border-b-2 dark:border-zinc-800">
                <ShowLiveStream
                  playbackId={this.props.playbackId}
                  playbackURL={this.props.playbackURL}
                  logMinuteAttended={this.props.logMinuteAttended}
                />
                <LivestreamCreatorDetails
                  account={this.props.account}
                  creatorAddress={this.props.creatorAddress}
                  creatorImage={this.props.creatorImage}
                  creatorName={this.props.creatorName}
                  item={this.props.item}
                  socials={this.props.socials}
                  subscriberStatuses={this.props.subscriberStatuses}
                  selectSubscribeModal={this.props.selectSubscribeModal}
                />
              </div>
              <ChatAndFlyingObjects
                address={this.props.account != null ? this.props.account.address : "anon " + Math.floor(Math.random() * 1000)}
                creatorAddress={this.props.creatorAddress}
                creatorName={this.props.creatorName}
                emotes={this.props.emotes}
                ens={this.props.ens}
                setENS={this.props.setENS}
                setAddresses={this.props.setAddresses}
                addAddress={this.props.addAddress}
                removeAddress={this.props.removeAddress}
                addresses={this.props.addresses}
                messages={this.props.messages}
                addMessage={this.props.addMessage}
                setAnimatedImageForUser={this.props.setAnimatedImageForUser}
                setTransactionStatus={this.props.setTransactionStatus}
                currentMessage={this.props.currentMessage}
                mintFromChat={this.props.mintFromChat}
                payStreamer={this.props.payStreamer}
                updateCurrentMessage={this.props.updateCurrentMessage}
                updateUserInfo={this.props.updateUserInfo}
                userInfo={this.props.userInfo}
                badgeInfo={this.props.badgeInfo}
                userOwnedNFTs={this.props.userOwnedNFTs}
                nftSalesLivestream={this.props.nftSalesLivestream}
                triggerAnimation={this.props.triggerAnimation}
                setMessageInfo={this.props.setMessageInfo}
                nextToken={this.props.nextToken}
                addPaginatedMessages={this.props.addPaginatedMessages}
                addSubscribedMessage={this.props.addSubscribedMessage}
              />
              <div className="md:hidden flex">
                <NFTSalesLivestream
                  address={this.props.account != null ? this.props.account.address : null}
                  setTransactionStatus={this.props.setTransactionStatus}
                />
              </div>
            </div>
            {/* <ProfileInformationContainer/> */}
          </div>
        </div>
      </div>
    );
  }
}

export default LivestreamPage;
